import { useEffect, useReducer } from 'react';

export default function useRecurly() {
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  useEffect(() => {
    function onLoad() {
      forceUpdate();
    }

    let script: HTMLScriptElement;

    function loadRecurly() {
      const src = 'https://js.recurly.com/v4/recurly.js';

      const existing = document.querySelector(`script[src="${src}"]`);

      if (!existing) {
        script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.addEventListener('load', onLoad);
        document.body.appendChild(script);
      }
    }

    if (typeof recurly === 'undefined') {
      loadRecurly();
    }

    return () => {
      if (script) {
        script.removeEventListener('load', onLoad);
      }
    };
  }, []);

  return typeof recurly !== 'undefined';
}
